import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// Eliminamos la importación de framer-motion
import { getCategory, createCategory, updateCategory } from '../../config/back4app';

const CategoryForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    image: '',
    status: 'active'
  });

  // Cargar datos de la categoría si estamos en modo edición
  useEffect(() => {
    if (id) {
      fetchCategory();
    }
  }, [id]);

  const fetchCategory = async () => {
    setLoading(true);
    try {
      const category = await getCategory(id);
      setFormData({
        name: category.name,
        description: category.description,
        image: category.image,
        status: category.status
      });
    } catch (err) {
      console.error('Error fetching category:', err);
      setError('Error al cargar la categoría');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      if (id) {
        await updateCategory(id, formData);
      } else {
        await createCategory(formData);
      }
      navigate('/admin/categories');
    } catch (err) {
      console.error('Error saving category:', err);
      setError('Error al guardar la categoría');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <p>Cargando...</p>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="row">
        {/* Formulario */}
        <div className="col-lg-8">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h1>{id ? 'Editar Categoría' : 'Nueva Categoría'}</h1>
            <button
              className="btn btn-secondary"
              onClick={() => navigate('/admin/categories')}
            >
              Cancelar
            </button>
          </div>

          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          <div className="card">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Nombre</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Descripción</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={formData.description}
                    onChange={(e) =>
                      setFormData({ ...formData, description: e.target.value })
                    }
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">URL de la Imagen</label>
                  <input
                    type="url"
                    className="form-control"
                    value={formData.image}
                    onChange={(e) =>
                      setFormData({ ...formData, image: e.target.value })
                    }
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Estado</label>
                  <select
                    className="form-select"
                    value={formData.status}
                    onChange={(e) =>
                      setFormData({ ...formData, status: e.target.value })
                    }
                  >
                    <option value="active">Activo</option>
                    <option value="inactive">Inactivo</option>
                  </select>
                </div>

                <div className="d-grid">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? 'Guardando...' : 'Guardar Categoría'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Preview */}
        <div className="col-lg-4">
          <div className="card">
            <div className="card-body">
              <h2 className="h5 mb-4">Vista Previa</h2>
              
              <div className="preview-card">
                {formData.image && (
                  <img
                    src={formData.image}
                    alt={formData.name}
                    className="img-fluid rounded mb-3"
                    style={{ width: '100%', height: '200px', objectFit: 'cover' }}
                  />
                )}
                <h3 className="h5 mb-2">{formData.name || 'Nombre de la Categoría'}</h3>
                <p className="text-muted mb-0">
                  {formData.description || 'Descripción de la categoría'}
                </p>
                <div className="mt-2">
                  <span className={`badge bg-${formData.status === 'active' ? 'success' : 'secondary'}`}>
                    {formData.status === 'active' ? 'Activo' : 'Inactivo'}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryForm;
